import React, { createContext, useState, useEffect, useContext } from "react";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../../AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup"
export const CustomerContext = createContext()
export const CustomerProvider = ({ children }) => {
  const { token } = useContext(AuthContext)
  // const [username, setUserName] = useState('');
  // const [profile, setProfile] = useState("")
  // const [email,setEmail]=useState("")
  // const [role, setRole] = useState("")
  // const [name,setName]=useState('')
  // const [id,setId]=useState(0)
  const [customerData,setCustomerData]=useState({
    name:"",
    profile:"",
    email:'',
    id:0,
    role:"",
    username:''    
  })
  const [data,setData]=useState([])
  const navigate = useNavigate()
  const [availableBanks, setAvailableBanks] = useState([])
  const [availableFarmers, setAvailableFarmers] = useState([])
  const [availableHotels, setAvailableHotels] = useState([])
  const [availableTransporters, setAvailableTransporters] = useState([])
  // states to hold relationships
  const [customerBanksData, setCustomerBanksData] = useState([])
  const [customerFarmersData, setCustomerFarmersData] = useState([])
  const [customerHotelsData, setCustomerHotelsData] = useState([])
  const [customerTransData, setCustomerTransData] = useState([])

  const [customerBankOwners, setCustomerBankOwners] = useState([])
  const [customerHotelOwners, setCustomerHotelOwners] = useState([])
  const [customerTransportOwners, setCustomerTransportOwners] = useState([])
 
  // Variable to hold admins
  const [admins, setAdmins] = useState([])
  const baseUrl =process.env.REACT_APP_SECOND_BACKEND_URL;
  const [relToDel, setRelToDel] = useState(false)

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token)
      const {role,username,profile,id,name,email}=decodedToken?.sub;
      if (role !== "customer") {
        navigate("/unauthorized")
        return;
      }
      fetchCustomerInfo(id)
      setCustomerData((prevValue)=>(
      {
        ...prevValue,
        name:name?name:prevValue?.name,
        username:username?username:prevValue?.username,
        profile:profile?profile:prevValue?.profile,
        email:email?email:prevValue?.email,
        id:id?id:prevValue?.id,
        role:role?role:prevValue?.role
      }
     ))
    }
    else{
      navigate("/loginUser")
    }
  }, [token])

  
  // useEffect(() => {

  //   if (data.length > 0) {
  //     // Fetch banks and filter down the ones that a customer does not have and set it t the available banks
  //     axios.get(`${baseUrl}/banks`, {
  //       headers: {
  //         "Content-Type":"application/json",
  //         Authorization: `Bearer ${token}`
  //       }
  //     })
  //       .then(res => {
  //         const banksData = res.data
  //         // console.log(banksData)
  //         if (data[0]?.Banks?.length > 0) {
  //           setCustomerBanksData(data[0].Banks)
  //           const customerBanksName = data[0].Banks.map((bank) => bank.name)
  //           const filteredBanks = banksData.filter(bank => !customerBanksName.includes(bank.name))
  //           setAvailableBanks(filteredBanks)
  //         }
  //         else {
  //           setAvailableBanks(banksData)
  //         }
  //       })
  //       .catch(error => {
  //         console.error("An error occurred", error)
  //       })
  //     //  Fetch all farmers and filter down to exclude the one that a user has and set it to the available farmers
  //     axios.get(`${baseUrl}/farmers`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     })
  //       .then(res => {
  //         const farmersData = res.data
  //         if (data[0]?.Farmers?.length > 0) {
  //           setCustomerFarmersData(data[0].Farmers)
  //           const customerFarmersName = data[0].Farmers.map((farmer) => farmer.username)
  //           setAvailableFarmers(farmersData.filter(farmer => !customerFarmersName.includes(farmer.username)))
  //         }
  //         else {
  //           setAvailableFarmers(farmersData)
  //         }

  //       })
  //       .catch(error => {
  //         console.error("An error occurred", error)
  //       })

  //     axios.get(`${baseUrl}/hotels`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     })
  //       .then(res => {
  //         let hotelsData = res.data
  //         if (data[0]?.Hotels?.length > 0) {
  //           setCustomerHotelsData(data[0].Hotels)
  //           const customerHotelsName = data[0].Hotels.map((hotel) => hotel.name)
  //           setAvailableHotels(hotelsData.filter(hotel => !customerHotelsName.includes(hotel.name)))
  //         }
  //         else {
  //           setAvailableHotels(hotelsData)
  //         }

  //       })
  //       .catch(error => {
  //         console.error("An error occurred", error)
  //       })
  //     // Fetching a transporter
  //     axios.get(`${baseUrl}/transporters`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     })
  //       .then((res) => {
  //         let transData = res.data
  //         if (data[0]?.Transporters?.length > 0) {
  //           let customerTransName = data[0].Transporters.map((trans) => trans.name)
  //           setAvailableTransporters(transData.filter((transporter) => !customerTransName.includes(transporter.name)))
  //         }
  //         else {
  //           setAvailableTransporters(transData)
  //         }
  //       })
  //   }
  // }, [data])

    // useEffect to ensure that a username always has a value 
  useEffect(() => {
    if (customerData?.username) {
      formik.setFieldValue("customer_username",customerData?.username)
    }
  }, [customerData?.username])
  // UseEffect for fetching admins
  useEffect(() => {
    axios.get(`${baseUrl}/admins`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        const adminData = res.data;        
        setAdmins(adminData)
      }).catch(error => {
        console.error(`An error ocurred fetcing admins ${error}`)
      })
  }, [])
  // Function to fetch customerData
  const fetchCustomerInfo = function (id) {
    try {      
      axios.get(`${baseUrl}/customers/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          const allData = response?.data; 
          // console.log("allData",allData)                  
          setData(allData);
          if (allData.length > 0) {
            if (allData[0]?.Farmers?.length > 0) {  
                //get all farmers                
                const AllFarmers=data[0]?.AllFarmers;
                if(allData[0].Farmers.length>0){
                       // Get the farmer ids
                const farmerIds=allData[0].Farmers.map(farmer=>farmer.id)
                // filter  out the farmers that a cusoemr does nothave
               if(farmerIds.length>0 && AllFarmers.length>0){
                 const filteredFarmers=AllFarmers.filter(farmer=>!AllFarmers.includes(farmer.id))
                 setAvailableFarmers(filteredFarmers)
               }
                }
                            
                      // Get the unique  farmrs
              let newCustomerFarmersData = allData[0].Farmers;              
              if (newCustomerFarmersData.length>0){
                const uniqueFarmers = [...new Set(newCustomerFarmersData.map((farmer) => farmer.username))].map((username) => newCustomerFarmersData.find((farmer) => farmer.username === username))
                setCustomerFarmersData(uniqueFarmers);    
              }
           }
            if (allData[0]?.Hotels?.length > 0) {
              // get the available hotels
              const allHotels=allData[0]?.AllHotels;
              if (allHotels.length>0 && allData[0]?.Hotels.length>0){
                const hotelOwnerIds=allData[0].Hotels.map(hotel=>hotel.id);
                const filtererdHotels=allHotels.filter(hotel=>!hotelOwnerIds.includes(hotel.id))
                setAvailableHotels(filtererdHotels);
              }
              setCustomerHotelsData(allData[0].Hotels);
              const newHotelOwners = allData[0].Hotels.flatMap((hotel) => hotel.owners);
              if(newHotelOwners.length>0){
              const uniqueHotelOwners = [...new Set(newHotelOwners.map(owner => owner.username))].map(username => newHotelOwners.find(owner => owner.username === username));
              setCustomerHotelOwners(uniqueHotelOwners);
              }           
            }
            // Set the owners of banks
            if (allData[0]?.Banks?.length > 0) {
              // Getting available banks
              if(allData[0]?.AllBanks.length>0){
                const allBankOwnerBankIds=allData[0].Banks.map(bank=>bank.id);
                const filteredBanks=allData[0]?.AllBanks.filter(bank=>!allBankOwnerBankIds.includes(bank.id));
                setAvailableBanks(filteredBanks);
              }
              setCustomerBanksData(allData[0]?.Banks);
              const newBankOwners = allData[0].Banks.flatMap(bank => bank.owners);
             if(newBankOwners.length>0){
              const uniqueBankOwners = [...new Set(newBankOwners.map((bankOwner) => bankOwner.username))].map(username => newBankOwners.find(bo => bo.username === username));
              setCustomerBankOwners(uniqueBankOwners);
             }
            }            
            if (allData[0]?.Transporters?.length > 0) {
              // get  all Trasporters anf filter down  the transporters
              const allTransporters=allData[0]?.AllTransporters;
              const transportOwnerTransporterIds=allData[0]?.Transporters.map(transporter=>transporter.id);
              const filteredTronsporters=allTransporters.filter(trans=>!transportOwnerTransporterIds.includes(trans.id));
              setAvailableTransporters(filteredTronsporters)
              setCustomerTransData(allData[0]?.Transporters)
              const newTransOwners=allData[0]?.Transporters.flatMap((transOwner)=>transOwner?.owners)              
              if(newTransOwners.length>0){
                const uniqueTransOwners=[...new Set(newTransOwners.map(transOwner=>transOwner.username))].map(username=>newTransOwners.find(to=>to.username===username))
                setCustomerTransportOwners(uniqueTransOwners)
              }
            } else {
              console.error("No transporters found for the user.");
            }

          }
        })
        .catch(error => {
          console.error('Error fetching customer data:', error);
        });
      } catch (error) {
      console.error(`Error fetching farmer information ${error}`);
    }
  };

  useEffect(() => {
    if (customerData?.profile) {
      fetchProfile()
    }
    else{
      return
    }
  }, [customerData?.profile])
  
  const fetchProfile = async () => {
    try {      
      const res = await fetch(`${baseUrl}/uploads/${customerData?.profile}_profile_picture.png`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (res.ok) {
        let blob = await res?.blob()
        let url = URL.createObjectURL(blob)
        setCustomerData((prevValue)=>({
          ...prevValue,
          profile:url
        }))
        
      }
      else{
        setCustomerData((prev)=>({
          ...prev,
          profile:''
        }))
      }
       }   catch (error) {
      console.error(`An error occurred fetching profiles`, error)
    }

  }

  const formik = useFormik({
    initialValues: {
      customer_username:customerData?.username,
      name: ""
    },
    validationSchema: yup.object().shape({
      name: yup.string("Name should be a string").required("Name is required").typeError("Name should be a string"),
      customer_username:yup.string().required("Username is required ").typeError("Username is required")
    }
    ),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (relToDel) {
          await requestDelRel(values)
          setRelToDel(false)
        }
        else {
          await requestAddRelationship(values)         
          setRelToDel(false)
        }
      } catch (error) {
        // console.log(values)
        console.error("An error occured  sending additin request", error)
      }
      finally {
        setSubmitting(false)
      }
    }
  })
  const requestAddRelationship = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/login/admin/customers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(values)
      })
      if(res.ok){
        alert(`Request to add ${values.name} sent sucessfully`)
        fetchCustomerInfo(customerData?.id)
      }
      else{
        if(res.status===500){
          alert(`An error ocurred adding ${values?.name}`)
        }
        else{
          const errMessage=await res.json()
          alert(`An error ocurred adding ${values.name}:${errMessage.Error || errMessage.Message}`)
        }
      }
    } catch (error) {
      console.error("An error occurred", error)
    }
  }

  const requestDelRel = async (values) => {
    try {
      if (!window.confirm(`Are you sure you want to delete ${values.name}`)) return;
      else {
        const res = await fetch(`${baseUrl}/login/admin/customers`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(values)
        })
        if (res.ok) {
          alert(`${values?.name} deleted successfully`)
          fetchCustomerInfo(customerData?.id)
        }
        else{
          if(res.status===500){
            alert(`An error ocurred deleting ${values?.name},please try again`);
          }
          else{
            const errMessage=await res.json()
            alert(`An error ocurred deleting ${values.name}:${errMessage.Error || errMessage.Message}`)
          }
        }
      }
    }
    catch (error) {
      console.error("An error occurred", error)
    }

  }


  // Pagination states
  const [postsPerPage, setPostPerPage] = useState(4)
  const [currentPage, setCurrentPage] = useState(1)
  const indexOfLastPost = (postsPerPage * currentPage)
  const indexOfFirstPost = indexOfLastPost - postsPerPage

  const paginate = (number) => {
    setCurrentPage(number)
  }
  // PAGINATION
  const newCustomerBanksData = customerBanksData.length > 4 ? customerBanksData.slice(indexOfFirstPost, indexOfLastPost) : customerBanksData
  const newCustomerHotelsData = customerHotelsData.length > 4 ? customerHotelsData.slice(indexOfFirstPost, indexOfLastPost) : customerHotelsData
  const newCustomerTransData=customerTransData.length>4?customerTransData.slice(indexOfFirstPost,indexOfLastPost):customerTransData
    const handleSendMessage = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/messages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(values)
      })
      if (res.ok) {       
      }
      else {
       if(res.status===500){
        alert("An error occurred sending message ,please try again")
       }
       else{
        let errMessage=await res.json()
        alert(`An error ocurred sending messages ${errMessage?.Error || errMessage?.Message}`)
       }
      }
    } catch (error) {
      console.error("An error occurred sending message", error)
    }
  }

  let contextValues = {
    customerData,    
    baseUrl,
    token,
    data,
    newCustomerTransData,
    navigate, admins,
     handleSendMessage, newCustomerBanksData, newCustomerHotelsData,
    // Function for relationships
    availableBanks, availableFarmers, availableHotels, customerBanksData, customerFarmersData, customerHotelsData, formik, setRelToDel, relToDel, postsPerPage, currentPage, paginate, customerBanksData, availableTransporters, customerTransData,
    // values of the owners of relationships
    customerHotelOwners, customerBankOwners, customerTransportOwners, setAvailableTransporters, baseUrl
  }
  
  return (
    <CustomerContext.Provider value={contextValues}>
      {children}
    </CustomerContext.Provider>
  )

}